import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Label,
  Input,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  getServices,
  deleteService,
  resetServices,
} from "../../../../store/service/actions";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  DataTable,
  TableRowField,
  ExportCSV,
  MainLoader,
} from "../../../../components";
import { selectUserRole } from "../../../../store/user/selector";
import { selectCategoriesForSelect } from "../../../../store/category/selector";
import {
  getCategories,
  resetCategories,
} from "../../../../store/category/actions";
import { roles, layout } from "../../../../common/constants";
import { formatHelper } from "../../../../common/helpers";
import MediaQuery from "react-responsive";
import { getAll as allServicesExport } from "../../../../service/service";
import { exportExcel } from "./excel";
class ServiceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      filter: "",
      selectedCategory: null,
      loadingExport: false,
    };
    this.handleObtainServicesExport =
      this.handleObtainServicesExport.bind(this);

    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
  }

  async componentDidMount() {
    await this.props.getCategories({ reset: true });
    this.performGetServices(true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.categories.length == 0 && this.props.categories.length > 0) {
      this.setState({ selectedCategory: this.props.categories[0] });
    }

    this.checkServiceDelete(prevProps);
  }

  componentWillUnmount() {
    this.props.resetServices();
  }

  performGetServices(reset = false) {
    const { categories, getServices } = this.props;
    const { page, filter, selectedCategory } = this.state;

    if (categories.length == 0) return;

    var categoryId = 0;
    if (selectedCategory) categoryId = selectedCategory.value;

    getServices({ page, filter, categoryId, reset });
  }

  async filterServices() {
    await this.setState({ page: 1 });
    this.performGetServices();
  }

  handleInputFilterChange(e) {
    if (e.key === "Enter") {
      this.filterServices();
    }
  }

  async checkServiceDelete(prevProps) {
    if (prevProps.deletedService == null && this.props.deletedService != null) {
      toast.success("Servicio eliminado satisfactoriamente");
      await this.setState({ page: 1 });
      this.performGetServices();
    } else if (
      prevProps.deleteError == null &&
      this.props.deleteError != null
    ) {
      toast.error(this.props.deleteError);
    }
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetServices();
  }

  performDeleteCategory(id) {
    Swal({
      title: "Eliminar servicio",
      text: "¿Estás seguro que deseas eliminar el servicio?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.props.deleteService(id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  async handleCategoryChange(value) {
    if (value == this.state.selectedCategory) return;
    await this.setState({ selectedCategory: value, page: 1 });
    this.filterServices();
  }

  optionsFormatterColumn(cell, row) {
    if (this.props.role == roles.SUPER_ADMIN) {
      return (
        <UncontrolledButtonDropdown>
          <DropdownToggle size="sm" color="primary">
            <i className="fa fa-bars" />
          </DropdownToggle>
          <DropdownMenu>
            {/* <DropdownItem onClick={() => this.props.history.push(`/administration/services/${row.id}/detail`)} ><i className="fa fa-eye mr-1" ></i> Detalle</DropdownItem> */}
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/services/${row.id}/edit`
                )
              }
            >
              <i className="fa fa-edit mr-1" /> Editar
            </DropdownItem>
            <DropdownItem
              disabled={this.props.deleteLoading}
              onClick={() => this.performDeleteCategory(row.id)}
            >
              <i className="fa fa-trash mr-1" /> Eliminar
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      );
    }
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.services}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  async handleObtainServicesExport() {
    this.setState({ loadingExport: true });
    allServicesExport(0, null, 0)
      .then((response) => {
        exportExcel(response.data.data);
      })
      .finally(() => this.setState({ loadingExport: false }));
  }

  render() {
    const optionsColumn = {
      dataField: "",
      text: "",
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const columnsXS = [
      {
        dataField: "xs",
        text: "Servicio",
        formatter: (cell, row) => {
          const categoryName = row.Category ? row.Category.name : "";

          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="Categoría:" value={categoryName} />
              <TableRowField
                label="Precio (S/):"
                value={formatHelper.toMoney(row.price)}
              />
              <TableRowField
                label="Descuento (%):"
                value={formatHelper.toBlankDiscount(row.discount)}
              />
            </div>
          );
        },
      },
    ];

    const columns = [
      {
        dataField: "name",
        text: "Nombre",
      },
      {
        dataField: "Category.name",
        text: "Categoría",
      },
      {
        dataField: "price",
        text: "Precio (S/)",
        formatter: (cell) => {
          return <span>{formatHelper.toMoney(cell)}</span>;
        },
      },
      {
        dataField: "discount",
        text: "Descuento (%)",
        formatter: (cell) => {
          return <span>{formatHelper.toBlankDiscount(cell)}</span>;
        },
      },
    ];

    if (this.props.role == roles.SUPER_ADMIN) {
      columns.push(optionsColumn);
      columnsXS.push(optionsColumn);
    }

    if (this.props.loading || this.props.loadingCategories) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-tag" />
            Servicios
          </CardHeader>
          <CardBody>
            <MediaQuery minDeviceWidth={600}>
              {(matches) => {
                if (matches) {
                  return (
                    <Row className="mb-2">
                      <Col sm="4">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterServices()}
                            >
                              <i className="fa fa-search" />
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="5">
                        <Row>
                          <Col md="3">
                            <Label className="mt-2">Categoría:</Label>
                          </Col>
                          <Col md="9">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingCategories}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.categories}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleCategoryChange}
                              value={this.state.selectedCategory}
                              isDisabled={this.props.loadingCategories}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm="3">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainServicesExport}
                        />
                      </Col>
                    </Row>
                  );
                } else {
                  return (
                    <Row className="mb-2">
                      <Col sm="4">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterServices()}
                            >
                              <i className="fa fa-search" />
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="5">
                        <Row>
                          <Col md="2">
                            <Label className="mt-2">Categoría:</Label>
                          </Col>
                          <Col md="10">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingCategories}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.categories}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleCategoryChange}
                              value={this.state.selectedCategory}
                              isDisabled={this.props.loadingCategories}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm="2">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainServicesExport}
                        />
                      </Col>
                    </Row>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            {this.props.role == roles.SUPER_ADMIN && (
              <Row className="mb-2">
                <Col>
                  <div className="float-right">
                    <Button
                      color="primary"
                      onClick={() =>
                        this.props.history.push("/administration/services/add")
                      }
                    >
                      <i className="fa fa-plus mr-1" /> Nuevo
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery minWidth={layout.SM_MIN_WIDTH}>
                  {this.renderDataTable(columns)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { services, error, loading, pageSize, total } =
    state.service.serviceList;

  return {
    services,
    error,
    loading,
    pageSize,
    total,
    categories: selectCategoriesForSelect(state),
    loadingCategories: state.category.categoryList.loading,
    deletedService: state.service.deleteService.service,
    deleteError: state.service.deleteService.error,
    deleteLoading: state.service.deleteService.loading,
    role: selectUserRole(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getServices,
      deleteService,
      resetServices,
      getCategories,
      resetCategories,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceList);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Service/ServiceList/ServiceList.js